export const builders = [
  'marge@navin.ee',
  'sten.vallimae@gmail.com',
  'marisborn@gmail.com',
  'antsovvirko@gmail.com',
  'piret.roop@gmail.com',
  'vaherkata@gmail.com'
];
